<template>
  <b-card id="page-membership" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-start"
    >
      <b-col cols="12" sm="12" md="4" lg="4" xl="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
      </b-col>
    </b-card-header>

    <!-- Table for larger devices -->

    <b-table
      id="payment-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(nameStatus)="data">
        <slot name="cell-nameStatus" :data="data">
          <b-badge pill :variant="data.item.colorStatus">
            <span>{{ data.item.nameStatus }}</span>
          </b-badge>
        </slot>
      </template>

      <template #cell(actions)="data">
        <feather-icon
          v-if="data.item.idCatStatus == 25"
          class="text-success mr-25"
          size="18"
          icon="DownloadCloudIcon"
          @click="onDownload(data.item.idSubscriptionPayment)"
        />

        <feather-icon
          v-if="data.item.idCatStatus == 24"
          class="text-primary mr-25"
          size="18"
          icon="CheckIcon"
          @click="onConfir(data.item)"
        />
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>
    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.idSubscriptionPayment"
          class="flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong>
              {{
                item.namePaymentType != null ? item.namePaymentType : "-"
              }}</strong
            >
            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
              v-if="item.idCatStatus != 24"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item
                v-if="item.idCatStatus == 25"
                @click="onDownload(data.item.idSubscriptionPayment)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("download") }}
                  <feather-icon
                    class="text-success mr-25"
                    size="18"
                    icon="DownloadCloudIcon"
                  />
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          {{ $t(labelHeader("amounth")) }} :
          {{ item.amount != null ? item.amount + " " + "$" : "-" }}<br />
          {{ $t(labelHeader("date")) }} :
          {{
            item.date != null
              ? new Date(item.date).toLocaleDateString("en-GB")
              : "-"
          }}<br />
          <b-badge pill :variant="item.colorStatus">
            <span>{{ item.nameStatus }}</span>
          </b-badge>
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>

    <b-modal
      v-model="modal_payment"
      centered
      hide-footer
      no-close-on-backdrop
      size="sm"
    >
      <template #modal-title>
        {{ $t(labelHeader("validate_pay")) }}
      </template>

      <b-card-text style="margin-bottom: -1.5rem !important">
        <b-card class="" no-body>
          <b-card-body v-if="membershipData != null">
            <span class="font-weight-bolder">
              {{ $t(labelHeader("name_company")) }} :</span
            >
            {{ membershipData.company.name }} <br />
            <span class="font-weight-bolder">
              {{ $t(labelHeader("name_subscription")) }} :</span
            >
            {{ membershipData.subscription.name }} <br />
            <span class="font-weight-bolder">
              {{ $t(labelHeader("name_payment_type")) }} :</span
            >
            {{ membershipData.namePaymentType }} <br />
            <span class="font-weight-bolder">
              {{ $t(labelHeader("amounth")) }} :</span
            >
            {{ membershipData.amount + " " + "$" }} <br />
            <span class="font-weight-bolder">
              {{ $t(labelHeader("date")) }} :</span
            >
            {{ new Date(membershipData.date).toLocaleDateString("en-GB") }}
            <br />
            <span class="font-weight-bolder">
              {{ $t(labelHeader("referencePay")) }} :</span
            >
            {{ membershipData.referenceNumber }} <br />
            <!-- <pre> {{ membershipData}}</pre> -->
            <a
              class="text-info font-weight-bolder"
              :href="membershipData.urlProofOfPayment"
              target="_blank"
            >
              {{ $t(labelHeader("voucher")) }}</a
            >
          </b-card-body>

          <div class="text-center mb-1">
            <b-button
              style="width: 60% !important"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="confirmatePayment"
            >
              {{ $t(labelHeader("confirmate_pay")) }}
            </b-button>
          </div>
        </b-card>
      </b-card-text>
    </b-modal>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCardText,
  BCardBody,
  BFormInvalidFeedback,
  BFormFile,
  BInputGroup,
  BCardGroup,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import { getParams } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";
import {
  allCompanyListPayments,
  getInvoice,
  confirmatedPaymentSubcription,
} from "@core/api/request/membership";

import { required } from "@validations";

import Cleave from "vue-cleave-component";
export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    vSelect,
    Filterss,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BCardText,
    BCardBody,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    Cleave,
    BFormFile,
    BInputGroup,
    BCardGroup,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data: () => ({
    loading: false,
    required,
    totalRows: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    items: [],
    companyGuid: null,
    fields: [
      { label: "name_payment_type", key: "namePaymentType", sortable: true },
      {
        label: "amounth",
        key: "amount",
        sortable: true,
        formatter: (value, key, item) => {
          let date;
          if (item.amount != null) {
            date = item.amount + " " + "$";
          } else {
            date = " - ";
          }
          return date;
        },
      },
      {
        label: "date",
        key: "date",
        sortable: true,
        formatter: (value, key, item) => {
          let date;
          if (item.date != null) {
            date = new Date(item.date).toLocaleDateString("en-GB");
          } else {
            date = " - ";
          }
          return date;
        },
      },
      { label: "name_status", key: "nameStatus", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    fields2: [
      { label: "name_company", key: "company.name", sortable: true },
      { label: "name_subscription", key: "subscription.name", sortable: true },
      { label: "name_payment_type", key: "namePaymentType", sortable: true },
      {
        label: "amounth",
        key: "amount",
        sortable: true,
        formatter: (value, key, item) => {
          let date;
          if (item.amount != null) {
            date = item.amount + " " + "$";
          } else {
            date = " - ";
          }
          return date;
        },
      },
      {
        label: "date",
        key: "date",
        sortable: true,
        formatter: (value, key, item) => {
          let date;
          if (item.date != null) {
            date = new Date(item.date).toLocaleDateString("en-GB");
          } else {
            date = " - ";
          }
          return date;
        },
      },
      { label: "name_status", key: "nameStatus", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "nombre",
        placeholder: "nombre",
        type: "text",
        reference: "name",
        visible: true,
      },
    ],
    appliedFilters: {},
    type_user: null,
    active: null,
    guidSubscription: null,
    membershipData: null,
    changes_memmbership: false,
    pay_membership: false,
    modal_membership: false,
    allSubcriptions: [],
    subscripcion: null,
    id_subscripcion_membership: null,
    subscriptionData: null,
    subscripcionSelect: false,
    payAviable: false,
    allPayMethodes: [],
    pay_methodes: null,
    paySelect: false,
    amounth: null,
    options: {
      number: {
        // numeralDecimalMark: '.',
        // delimiter: ',',
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        numeralDecimalScale: 3,
        numeralPositiveOnly: true,
      },
    },
    voucher: null,
    referencePay: null,
    urlVoucher: null,
    modal_payment: false,
    name: null,
    filtersOn: false,
    hasNextPage: true,
  }),

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.loadPaymenths();
    },
  },
  async mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    await this.loadPaymenths();
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadPaymenthsInfinity();
      }
    },
    label(field) {
      return `pages.membership.table.${field}`;
    },

    labelHeader(field) {
      return `pages.membership.table.tableHeader.${field}`;
    },
    tagsColor(status) {
      if (status) return "light-success";
      else return "light-danger";
    },

    chargeParamsByAdmin() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);
      if (
        this.companyGuid != null &&
        this.companyGuid.trim() !== "" &&
        this.companyGuid != "null"
      )
        arrParams.push(`guidCompany,${this.companyGuid}`);

      return getParams(arrParams);
    },
    chargeParamsByCompanie() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);
      arrParams.push(`guidCompany,${this.companyGuid}`);

      return getParams(arrParams);
    },
    async onDownload(idSubscriptionPayment) {
      await getInvoice(idSubscriptionPayment)
        .then((resp) => {
          const data = _.get(resp, "data");

          window.open(data, "_blank");
        })
        .catch((error) => {});
    },
    onConfir(data) {
      this.membershipData = data;
      this.modal_payment = true;
    },
    async confirmatePayment() {
      let confir = {
        idSubscriptionPayment: this.membershipData.idSubscriptionPayment,
        idSubscriptionCompany: this.membershipData.idSubscriptionCompany,
      };

      await confirmatedPaymentSubcription(confir)
        .then((resp) => {
          if (!resp.err) {
            this.alertToast("success", `Exito`, "Confirmación pago exitoso");

            this.modal_payment = false;
            this.loadPaymenths();
          } else {
            this.alertToast("danger", "Alerta error", "Hubo un error");
          }
        })
        .catch((error) => {});
    },
    async loadPaymenths() {
      this.loading = !this.loading;
      if (!this.hasNextPage) return;
      const param = this.chargeParamsByCompanie();
      await allCompanyListPayments(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    async loadPaymenthsInfinity() {
      this.loading = !this.loading;
      if (!this.hasNextPage) return;
      const param = this.chargeParamsByCompanie();
      await allCompanyListPayments(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = [...this.items, ...data?.items];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          this.hasNextPage = data?.currentPage < data?.totalPages || 0;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handlePerPageChange() {
      this.currentPage = 1;
      this.loadPaymenths();
    },
    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadPaymenths();
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style></style>
